<template>
  <div class="authority-manage rhBrand-box position-header">
    <navHeader :titleList="['产品管理', '专业产品']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row>
          <el-col :span="5">
            <span class="search-text">关联品牌：</span>
            <el-select filterable v-model="brandId" placeholder="请选择" class="search-item" clearable size="small">
              <el-option v-for="item in brands" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <span class="search-text">名称：</span>
            <el-input class="search-item" placeholder="请输入" v-model.trim="name" size="small"></el-input>
          </el-col>
          <el-col :span="5">
            <span class="search-text">零售价：</span>
            <el-input class="search-item" placeholder="请填入数字" v-model.trim="price" size="small"></el-input>
          </el-col>
          <el-col :span="5">
            <span class="search-text">状态：</span>
            <el-select v-model="status" placeholder="请选择" class="search-item" size="small">
              <el-option v-for="item in statuses" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button class="btn-search" round icon="el-icon-search" @click="getPageList" size="small">搜索</el-button>
            <el-button type="warning" round icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-col :span="12">
            <el-button class="btns-add" icon="el-icon-plus" size="small" @click="add"
              v-if="hasPerm('add-btns')">添加</el-button>
            <el-button :disabled="selectData.length === 0" type="danger" icon="el-icon-delete" size="small"
              @click="deleteMore">批量删除</el-button>
            <el-button :disabled="selectData.length === 0" type="primary" icon="el-icon-edit-outlin" size="small"
              @click="verifyMore" v-if="hasPerm('verify-btns')">批量审核</el-button>
          </el-col>
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" border style="width: 100%" class="flex-1" stripe height="100%" @selection-change="selectRow"
            @cell-click="cell_click">
            <el-table-column type="selection" width="60px" fixed align="center"> </el-table-column>
            <el-table-column prop="sort" sortable width="250" label="排序" align="center">
              <template slot-scope="scope">
                <div class="cell_btn" style="display: flex"
                  v-if="scope.row.id === cell_click_id && cell_click_label === '排序'">
                  <el-input-number style="margin-right: 10px" size="mini" :min="1" placeholder="请输入排序"
                    v-model="scope.row.sort" />
                  <el-button type="primary" size="mini" icon="el-icon-edit" circle
                    @click="determine_modify(scope.row)"></el-button>
                  <el-button type="warning" size="mini" icon="el-icon-close" circle
                    @click="cancelSort('cancel_edit', scope.row)"></el-button>
                  <el-tooltip class="item" effect="dark" content="数值越小越靠前；无数值的排最后；数值一致，按时间倒序排" placement="top">
                    <div class="question-tip"></div>
                  </el-tooltip>
                </div>
                <span v-else>{{ scope.row.sort }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="brandId" align="center" show-overflow-tooltip label="关联品牌" width="160">
              <template slot-scope="scope">
                {{ getBrandName(scope.row.brandId) }}
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" show-overflow-tooltip label="名称" width="160">
            </el-table-column>
            <el-table-column prop="picture" align="center" label="图片" width="160">
              <template slot-scope="scope">
                <el-image v-if="scope.row.picture" style="width: auto; height: 60px" :src="scope.row.pictureSrc"
                  :preview-src-list="scope.row.pictureList" fit="contain"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="price" align="center" show-overflow-tooltip label="零售价" width="160">
              <template slot-scope="scope">
                {{ fixedNum(scope.row.price) }}
              </template>
            </el-table-column>
            <el-table-column prop="category" align="center" show-overflow-tooltip label="品类" width="160">
              <template slot-scope="scope">
                {{ getCategory(scope.row.category) }}
              </template>
            </el-table-column>
            <el-table-column prop="address" align="center" show-overflow-tooltip label="生产地" width="160">
              <template slot-scope="scope">
                {{ getAddress(scope.row.address) }}
              </template>
            </el-table-column>
            <el-table-column prop="factory" align="center" show-overflow-tooltip label="生产企业" width="160">
            </el-table-column>
            <el-table-column prop="status" align="center" show-overflow-tooltip label="状态" width="160">
              <template slot-scope="scope">
                <span v-if="scope.row.status === '2'">通过</span>
                <span v-else-if="scope.row.status === '3'" class="reject-btns"
                  @click="checkRejectReason(scope.row.reason)">查看驳回原因</span>
                <span v-else>待审核</span>
              </template>
            </el-table-column>
            <el-table-column prop="size" align="center" show-overflow-tooltip label="规格" width="160">
            </el-table-column>
            <el-table-column prop="clientTime" width="180" label="操作时间" align="center" sortable></el-table-column>
            <el-table-column align="center" width="320" label="操作" fixed="right">
              <template slot-scope="scope">
                <div class="btn-box">
                  <el-button v-if="scope.row.status === '2'" icon="el-icon-thumb" type="text"
                    @click="getCord(scope.row.id, scope.row.name)" size="small">获取二维码</el-button>
                  <el-button icon="el-icon-edit" type="text" @click="edit(scope.row.id)" size="small">编辑</el-button>
                  <el-button icon="el-icon-document-checked" type="text" @click="
                    verify(
                      scope.row.id,
                      scope.row.status,
                      scope.row.reason
                    )
                  " size="small" v-if="hasPerm('verify-btns')">审核</el-button>
                  <el-button icon="el-icon-delete" type="text" @click="deleteInfo(scope.row.id)"
                    size="small">删除</el-button>
                  <el-button icon="el-icon-warning-outline" type="text"
                    @click="upAndDown(scope.row.id, scope.row.shelfStatus)" size="small">{{ scope.row.shelfStatus === '1'
                        ? '下架' : '上架'
                    }}</el-button>
                  <el-button icon="el-icon-document-checked" type="text" @click="onlinePreview(scope.row.id)"
                    size="small">网页预览</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, sizes"
            :total="total">
          </el-pagination>
        </el-row>
      </el-card>
    </div>
    <el-dialog title="审核" width="30%" :visible.sync="dialogShow" :close-on-click-modal="false" :show-close="false"
      @close="cancel">
      <el-form :model="verifyForm" :rules="verifyRules" ref="verifyForm" label-width="100px">
        <el-form-item label="审核" prop="status">
          <el-radio-group v-model="verifyForm.status" @change="verifySelect">
            <el-radio :label="'2'">审核通过</el-radio>
            <el-radio :label="'3'">审核驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" v-if="verifyForm.status === '3'" prop="reason">
          <el-checkbox-group v-model="checkList" @change="selectRemark">
            <el-checkbox label="系统判定为广告信息"></el-checkbox>
            <el-checkbox label="需求信息不明确"></el-checkbox>
            <el-checkbox label="公司信息不完整"></el-checkbox>
            <el-checkbox label="公司信息无法认证"></el-checkbox>
          </el-checkbox-group>
          <el-input type="textarea" v-model.trim="verifyForm.reason" :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
    <!--    <verifyDialog v-model="dialogShow" :verifySrc="verifySrc" :id="id" :verifyStatus="verifyStatus" :statusRemarks="statusRemarks" />-->
    <previewDialog v-model="previewShow" />
    <transition name="phone">
      <div class="phone-box" v-if="onlineShow" @click="onlineShow = false">
        <!-- <transition name="phone"> -->
        <iphoneX v-model="onlineShow" :src="onlineUrl" />
      </div>
    </transition>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'
import verifyDialog from '../../components/verifyDialog.vue'
import previewDialog from '../../components/previewDialog.vue'
import iphoneX from '../../components/iphonex.vue'

export default {
  data () {
    return {
      onlineUrl: '',
      id: '',
      brandId: '',
      brands: [],
      name: '',
      price: '',
      status: '',
      checkList: [],
      statuses: [
        {
          label: '待审核',
          value: '1'
        },
        {
          label: '通过',
          value: '2'
        },
        {
          label: '驳回',
          value: '3'
        }
      ],
      selectData: [],
      cell_click_id: '', // 点击的单元格
      cell_click_label: '', // 当前点击的列名
      tableData: [],
      tableHeight: 0,
      dialogShow: false,
      verifySrc: '',
      verifyStatus: '',
      reason: '',
      previewShow: false,
      onlineShow: false,
      verifyForm: {
        status: '1',
        reason: ''
      },
      verifyRules: {
        status: [
          {
            required: true
          }
        ],
        reason: [
          {
            required: true,
            message: '请填写理由',
            trigger: 'blur'
          }
        ]
      },
      originOptions: [],
      areaCodeList: [],
      brandCategoryList: [],
      currentPage: 1,
      pageSize: 10,
      total: 1
    }
  },
  components: {
    navHeader,
    verifyDialog,
    previewDialog,
    iphoneX
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'AddMajorProduct') {
      sessionStorage.setItem('currentPage', this.currentPage)
      sessionStorage.setItem('pageSize', this.pageSize)
      sessionStorage.setItem('chineseName', this.name)
      sessionStorage.setItem('status', this.status)
      sessionStorage.setItem('brandId', this.brandId)
      sessionStorage.setItem('price', this.price)
    } else {
      sessionStorage.removeItem('currentPage')
      sessionStorage.removeItem('pageSize')
      sessionStorage.removeItem('chineseName')
      sessionStorage.removeItem('status')
      sessionStorage.removeItem('brandId')
      sessionStorage.removeItem('price')
    }
    next()
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 380
    if (sessionStorage.getItem('currentPage')) this.currentPage = Number(sessionStorage.getItem('currentPage'))
    if (sessionStorage.getItem('pageSize')) this.pageSize = Number(sessionStorage.getItem('pageSize'))
    if (sessionStorage.getItem('chineseName')) this.name = sessionStorage.getItem('chineseName')
    if (sessionStorage.getItem('status')) this.status = sessionStorage.getItem('status')
    if (sessionStorage.getItem('brandId')) this.brandId = sessionStorage.getItem('brandId')
    if (sessionStorage.getItem('price')) this.price = sessionStorage.getItem('price')
    this.getPageList()
    this.getBrandList()
    this.getBrandCategoryList()
    this.getProducingAreaList()
    this.areaCode()
  },
  mounted () { },
  methods: {
    async getPageList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        name: this.name,
        brandId: this.brandId,
        status: this.status,
        price: this.price
      }
      let { data: res } = await this.$http.post(
        '/professionalProduct/professionalProduct/pageList',
        params
      )
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach(item => {
          if (item.picture) {
            item.pictureList = item.picture.split(',')
            item.pictureSrc = item.picture.split(',')[0]
          } else {
            item.pictureSrc = ''
            item.pictureList = []
          }
        })
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    async getBrandList () {
      let { data: res } = await this.$http.get(
        '/professionalProduct/professionalProduct/getBrandList'
      )
      if (res.code === '200') {
        this.brands = res.data
      }
    },
    getBrandCategoryList () {
      this.$http
        .get('/ProfessionalBrand/professionalBrand/getBrandCategoryList')
        .then((res) => {
          if (res.data.code === '200') {
            this.brandCategoryList = res.data.data
          }
        })
    },
    getProducingAreaList () {
      this.$http
        .get('/brandArea/getBrandAreaList')
        .then((res) => {
          if (res.data.code === '200') {
            this.originOptions = res.data.data
          }
        })
    },
    areaCode () {
      this.$http
        .get('/areaCode/getList')
        .then((res) => {
          if (res.data.code === '200') {
            this.areaCodeList = res.data.data
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    getBrandName (n) {
      let name = ''
      this.brands.forEach((item) => {
        if (item.id === n) {
          name = item.name
        }
      })
      return name
    },
    getCategory (n) {
      let name = ''
      this.brandCategoryList.forEach((item) => {
        item.children.forEach((i) => {
          if (i.id === n) {
            name = i.name
          }
        })
      })
      return name
    },
    getAddress (address) {
      let name = ''
      if (address && address.indexOf(',') > 0) {
        let list = address.split(',')
        let newArr = []
        this.originOptions.forEach(item => {
          list.forEach(i => {
            if (item.id === i) {
              newArr.push(item.name)
            }
          })
          item.children.forEach(n => {
            list.forEach(m => {
              if (n.id === m) {
                newArr.push(n.name)
              }
            })
          })
        })
        name = newArr.join('/')
      } else {
        this.areaCodeList.forEach(item => {
          if (item.id === address) {
            name = item.name
          }
        })
      }
      return name
    },
    fixedNum (n) {
      let num = ''
      if (n) {
        num = parseInt(n)
      } else {
        num = ''
      }
      return num
    },
    reset () {
      this.name = ''
      this.brandId = ''
      this.status = ''
      this.price = ''
      this.getPageList()
    },
    selectRow (selection) {
      this.selectData = selection
    },
    // 单元格点击事件
    cell_click (row, column) {
      this.cell_click_id = row.id
      this.cell_click_label = column.label
      if (column.label !== '排序') this.getPageList()
    },
    // 点击取消
    cancelSort (status, data) {
      this.getPageList()
      switch (status) {
        case 'cancel_edit':
          this.cell_click_id = ''
          this.cell_click_label = ''
          data.sort = ''
          break
        default:
          break
      }
    },
    // 确定修改
    determine_modify (row) {
      console.log(row)
      let params = {
        id: row.id,
        sort: row.sort
      }
      this.$http.post('/professionalProduct/professionalProduct/sort', params).then(res => {
        if (res.data.code === '200') {
          this.$message.success(res.data.msg)
          this.getPageList()
          this.cell_click_id = ''
          this.cell_click_label = ''
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    add () {
      this.$router.push('/addMajorProduct')
    },
    getCord (id, name) {
      this.$http.get('/wechatQRCode/getWechatQRCode/4/' + id, { responseType: 'blob' }).then(res => {
        console.log(res)
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/x-msdownload' }))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.download = name + '二维码.png'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      })
    },
    edit (id) {
      this.$router.push({
        name: 'AddMajorProduct',
        params: {
          id,
          type: 'edit'
        }
      })
    },
    checkRejectReason (reason) {
      this.$alert(reason, '驳回原因', {
        confirmButtonText: '确定'
      })
    },
    deleteMore () {
      let ids = this.selectData
        .map((item) => {
          return item.id
        })
        .join(',')
      this.$confirm(
        `确认删除选中的${this.selectData.length}条数据?`,
        '删除提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          showClose: false
        }
      )
        .then(() => {
          this.$http
            .post('/professionalProduct/professionalProduct/batchDelete', { ids })
            .then((res) => {
              if (res.data.code === '200') {
                this.$message.success('删除成功!')
                this.getPageList()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '删除失败'
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    exportAll () {
      this.$confirm(
        `确认导出选中的${this.selectData.length}条数据?`,
        '导出提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          showClose: false
        }
      )
        .then(() => {
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    selectRemark (val) {
      let remark = val.join(',')
      this.verifyForm.reason = remark
    },
    verifySelect () {
      this.verifyForm.reason = ''
    },
    verifyMore () {
      this.checkList = []
      this.dialogShow = true
      let list = this.selectData.map(item => item.id)
      this.id = list.join(',')
    },
    verify (id, status, reason) {
      this.checkList = []
      this.dialogShow = true
      this.id = id
      this.verifyForm.status = status
      this.verifyForm.reason = reason
    },
    confirm () {
      this.$refs.verifyForm.validate((val) => {
        if (val) {
          if (this.verifyForm.status !== '3') {
            this.verifyForm.reason = ''
          }
          let params = JSON.parse(JSON.stringify(this.verifyForm))
          params.ids = this.id
          this.$http
            .post('/professionalProduct/professionalProduct/audit', params)
            .then((res) => {
              if (res.data.code === '200') {
                this.dialogShow = false
                this.getPageList()
                this.$message.success(res.data.msg)
                this.checkList = []
              }
            })
        }
      })
    },
    cancel () {
      this.dialogShow = false
      this.verifyForm = {
        status: '',
        reason: ''
      }
    },
    addProduct () {
      this.$router.push('/addProduct')
    },
    deleteInfo (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http
          .post('/professionalProduct/professionalProduct/delete', { id })
          .then((res) => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
      })
    },
    upAndDown (id, shelfStatus) {
      let tip = ''
      let status = ''
      if (!shelfStatus || shelfStatus === '2') {
        tip = '确定上架该产品?'
        status = '1'
      } else {
        tip = '确定下架该产品?'
        status = '2'
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http
          .post('/professionalProduct/professionalProduct/modifyShelfStatus', { id, shelfStatus: status })
          .then((res) => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
          })
      })
    },
    onlinePreview (id) {
      this.onlineUrl = `/pages/Service_provider_product_details/Service_provider_product_details?id=${id}&type=3  `
      this.onlineShow = true
    },
    qrPreview () {
      this.previewShow = true
    }
  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/productManagement/major.vue